import { useStyles } from './styles';
import { Box, Button } from '@material-ui/core';
import { insertActivityLog } from '../../actions';
import { getAppSource, getUserType } from '../../helpers';
import { useSelector } from 'react-redux';
import { useState } from 'react';
import { LeavingSiteConfirmation } from '../../components';
import openIcon from '../../assets/openInNew.png';
import Cookies from 'js-cookie';

export const RefinanceCard = (props) => {

  const { bannerBody, bannerImageUrl, bannerTitle,
    buttonColor, buttonText, buttonURL, titleBgColor, bannerSubTitle, bannerName, refiCompany } = props.banner;
  const theme = useSelector(state => state.theme);
  const {lendingNumber} = theme;
  const [popupStatus, setPopup] = useState(false);
  const classes = useStyles();

  const linkStyle = {
    display: 'inline-flex',
    backgroundColor: '#1f4a63',
    borderRadius: '50px',
    padding: '10px 22px 10px 10px',
    fontFamily: 'Montserrat',
    cursor: 'pointer',
    margin: '0px 58px',
    textDecoration: 'none'
  };

  const iconWrapperStyle = {
    width: '50px',
    height: '28px',
    backgroundColor: '#ffffff',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '14px'
  };

  const numberWrapperStyle = {
    lineHeight: 1.2,
  };

  const route = () => {
    setPopup(true)
  }

  const sendActivityData = async () => {
    const remark = `User clicked on Continue button after clicking Apply Now button on refinance tile(${refiCompany}) on home page of MLW.`;
    const data = {
      "accountNumber":  Cookies.get("selectedAccount"),
      "activityCode": "UAL202",
      "activityStatus": "Success",
      "action": refiCompany,
      "controller": "Dashboard",
      "apiName": "GetAccountInfo",
      "activityRemark":  remark,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": "",
    };

    await insertActivityLog(data);
  }

  const handleOk = () => {
    setPopup(false)
    sendActivityData()
    window.open('https://bsifinancialrefinanceonline.mymortgage-online.com/', '_blank') 
  }

  return (
    <>
    <Box className={classes.root}>
      <Box className={classes.body}>
        <img className={classes.logo} src={bannerImageUrl} alt='banner logo' />
        <Box className={classes.bodyText} dangerouslySetInnerHTML={{ __html: bannerBody }}></Box>
      </Box> 

      <a href={`tel:${lendingNumber}`} style={linkStyle}>
        <Box style={iconWrapperStyle}>
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="#1f4a63"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
          >
            <path d="M6.62 10.79a15.054 15.054 0 006.59 6.59l2.2-2.2a1 1 0 011-.24c1.12.37 2.33.57 3.59.57a1 1 0 011 1V21a1 1 0 01-1 1C10.07 22 2 13.93 2 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.26.2 2.47.57 3.59a1 1 0 01-.25 1l-2.2 2.2z" />
          </svg>
        </Box>

        <Box style={numberWrapperStyle}>
          <Box className={classes.numberStyle}>{lendingNumber}</Box>
        </Box>
      </a>
 
      <Box className={classes.footer}>
        <Button onClick={() => route()} className={classes.btn} style={{ backgroundColor: buttonColor }}>{buttonText} <img src={openIcon} style={{ paddingLeft: '8px'}}/></Button> 
        <Button className={classes.resetButton} style={{ marginTop: 16 }} variant="outlined" onClick={() => props?.handleContactMe()}>Request Callback</Button>
      </Box>
    </Box>
    <LeavingSiteConfirmation 
        open={popupStatus}
        handleClose={() => setPopup(false)}
        handleOk={handleOk}
      />
    </>  
  )
}
